<template>
    <div>
    <b-navbar toggleable="md" type="dark" variant="info"  class="navbar navbar-expand-lg shadow" v-if="isLogged">

      <b-navbar-toggle target="nav_collapse">
        <menu-icon/>
      </b-navbar-toggle>

      <b-navbar-brand href="#">
        <router-link to="/" class="navbar-brand">
          <img src="./../../assets/images/logo.png" class="image-fluid" alt="Lembra Fácil">
        </router-link>
      </b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">

        <!-- <b-navbar-nav>
          menu at left
        </b-navbar-nav> -->

        <b-navbar-nav class="ml-auto ">
          <!-- simples routes -->
          <b-nav-item
          href="#"
          class="nav-item mr-4 text-center"
          :key='link.name'
          v-for="link in filterLinks(links, 'simple')">
            <router-link :to="{ name: link.name }" class="nav-link">
              <component :is="link.meta.icon"></component>
              <b-dropdown-divider></b-dropdown-divider>
              <span class="small"> {{link.meta.humanName}} </span>
            </router-link>
          </b-nav-item>

          <!-- nested routes -->
          <b-nav-item
            class="nav-item mr-4 text-center"
            :key='link.name'
            v-for="link in filterLinks(links, 'nested')">
            <b-nav-item-dropdown no-caret  >
              <template slot="button-content">
                <component :is="link.meta.icon"></component>
                <b-dropdown-divider></b-dropdown-divider>
                <span class="small"> {{link.meta.humanName}} </span>
              </template>

              <b-dropdown-item disabled class="header">
                {{link.meta.humanName}}
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item
                href="#"
                :key='sublink.name'
                v-for="sublink in filterLinks(link.children, 'sublink')"
              >
                <router-link :to="{ name: sublink.name }" class="nav-link dropdown-nav-link">{{sublink.meta.humanName}}</router-link>
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-nav-item>


          <!-- user menu -->
          <b-nav-item class="nav-item text-center">
            <a  @click="logout()" class="nav-link">
              <exit-icon/>
              <b-dropdown-divider></b-dropdown-divider>
              <span class="small"> Sair </span>
            </a>
          </b-nav-item>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>
    <nav aria-label="breadcrumb ">
      <div class="col-12">
        <ol class="breadcrumb  border-bottom">
          <li class="breadcrumb-item actualPage active" aria-current="page">{{currentMeta.humanName}}</li>
          <li class="breadcrumb-item pt-3" v-for="path in currentMeta.pathAlias" :key="path" aria-current="page">{{path}}</li>
        </ol>
      </div>
    </nav>
  </div>

</template>

<script>
import store from '@/store';
import jwtDecode from 'jwt-decode';

export default {
  name: 'app-nav',
  data() {
    return {
      links: [],
      currentMeta: '',
      token: {},
      api: '',
      decoded: '',
    };
  },
  methods: {
    logout() {
      this.$store.commit('user_logout');
    },
    getFile() {
      if (this.decoded && this.decoded.avatar) {
        let file = `${this.api}/api/v1/upload?`;
        file += `token=${this.token}`;
        file += `&mimetype=${this.decoded.avatar.mimetype}`;
        file += `&filename=${this.decoded.avatar.filename}`;
        file += `&folder=${this.decoded.avatar.folder}`;
        return file;
      } else {
        return '';
      }
    },
    filterLinks(links, tipo) {
      let newLinks = [];

      for (let i = 0; i < links.length; i++) {
        const link = links[i];

        if ( tipo == 'sublink' && link.meta.showOnNav) {
          newLinks.push(link);
        } else if ( tipo == 'simple' && (!link.children && link.meta.showOnNav)) {
          newLinks.push(link);
        } else if ( tipo == 'nested' && (link.children && link.meta.showOnNav)) {
          newLinks.push(link);
        }

      }

      return newLinks;
    },
  },
  computed: {
    isLogged() {
      return this.$store.getters.isLogged;
    },
  },
  mounted() {
    this.api = process.env.VUE_APP_API;
    this.links = this.$router.options.routes;
    this.decoded = this.$store.getters.decoded;
    this.token = this.$store.getters.authToken;
  },
  watch: {
    '$route' (to, from) {
      this.currentMeta = this.$route.meta;
    }
  }
};
</script>

<style scoped>

.breadcrumb {
  font-weight: 100;
  font-size: 13px;
  background-color:rgba(0, 0, 0, 0.0)
}

.breadcrumb .breadcrumb-item:nth-child(2)::before {
  content: "";
}

.actualPage{
  vertical-align: top;
  font-size: 28px;
  font-weight: 100;
  color: #ff6700;
  padding-top: 0px;
}


.collapse{
  width: 100%
}

.nav-item .header {
  opacity: .5;
  cursor: none !important;
}



</style>
